import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import translations from "../data/langData";
import { ApiLinkContext } from "../context/ApiLinkContext";

const AllTestimonials = () => {
  const { blog, loading, testimonials, error } = useContext(ApiLinkContext);
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  return (
    <>
      <div className="testimonial-section section">
        <div className="allTesti">
          <div className="container my-5">
            <div className="row justify-content-center g-3">
              {testimonials.map((item) => {
                return (
                  <div className="col-12">
                        <div className="testiBox">
                    <div className="row g-3">
                        <div className="col-lg-2 col-md-2 col-sm- 12 col-12 text-center">
                        <img
                          src={item.img}
                          alt="img"
                          style={{ borderRadius: "50%", width: "150px",objectFit:"cover" }}
                        />
                        </div>
                        <div className="col-lg-10 col-md-10 col-sm- 12 col-12">
                        <div className="testiText ms-3">
                          <p>
                            {item.name}{" "}
                            {[...Array(5)].map((_, index) => (
                              <i
                                key={index}
                                className={`fa-solid fa-star text-warning ms-2`}
                              ></i>
                            ))}
                            <p>{item.job}</p>
                          </p>
                          {item.text && (
                            <p
                              dangerouslySetInnerHTML={{
                                __html:
                                  language === "az" && item.text
                                    ? item.text
                                    : language === "en" && item.textEn
                                    ? item.textEn
                                    : language === "ru" && item.textRu
                                    ? item.textRu
                                    : language === "tr" && item.textTr
                                    ? item.textTr
                                    : language === "de" && item.textDe
                                    ? item.textDe
                                    : language === "pl" && item.textPl
                                    ? item.textPl
                                    : "",
                              }}
                            />
                          )}
                        </div>
                        </div>
                    </div>
                        </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllTestimonials;
